import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ConfirmLink',
  data: function () {
    return {
      accountActivated: null,
      errorMessage: '',
      activateAccountResultErrors: [
        this.$t('login.AccActivationError'),
        this.$t('login.AccActivationInvalidOtpCode'),
        this.$t('login.AccActivationExpiredOtpCode'),
        this.$t('login.AccActivationInvalidOtpCode'),
        this.$t('login.AccActivationExpiredOtpCode'),
      ],
      message: 'Please wait a moment ...',
      activationCode: '',
      otpCode: '',
      bOTPEnabled: false,
      isInComm: false,
      settings: null,
      successMsg: '',
      showRegistrationMessage: false,
      homeURL: '',
    }
  },
  computed: {
    activationMessage: function () {
      if (this.accountActivated)
        return !this.successMsg ? this.$t('login.AccountActivated') : this.successMsg;
      else if (this.accountActivated == false)
        return this.errorMessage;
      else
        return null;
    }
  },
  created() {
    this.activationCode = this.$route.params.code;
    this.getSettings();
  },
  methods: {
    showMessage(msg, type) {
      this.message = msg;
      if (type === 2)
        this.message += ' ' + this.$t('messages.ProblemPersistsContactSupport');
      this.$notify({ duration: 10000, group: 'app', text: msg, type: type == 1 ? 'warn' : type == 2 ? 'error' : type == 3 ? 'success' : '' });
    },
    login() {
      this.$router.push('/login');
    },
    goToHomepage() {
      window.location.href = this.homeURL;
    },
    getSettings() {
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.settings = response.data;

            if (!this.settings.customerLoginWithOtp) {
              axios.post('/account/ActivateAccount', { Value: this.activationCode, OtpCode: '' })
                .then(resp => {

                  if (resp.status == 200 && resp.data.data.status === 0) {
                    this.accountActivated = true;
                    axios.post('/Utility/GetMessage', { Lang: this.$i18n.locale, TextId: 85 })
                      .then(resp1 => {
                        if (resp1.data.data.status === 0) {
                          this.successMsg = resp1.data.settings.text;
                          this.homeURL = response.data.value.homeButtonUrl;
                          this.showRegistrationMessage = true;
                        }
                        //else
                        //  console.log("error", resp1.data.data.text);
                      })
                      .catch(err => console.log("error", err));
                  }
                  else {
                    this.handleAcitvationResponse(resp.data);
                  }


                })
                .catch(err => {
                  this.showMessage(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`, 2);
                });

              return;
            }

            this.bOTPEnabled = response.data.value.customerLoginWithOtp;
            if (!this.bOTPEnabled)
              this.confirmLink();
          }
        })
        .catch(err => err.data == undefined ? this.showMessage(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`, 2) :
          this.showMessage(err.data.data.text, 2))
        .finally(this.$root.$emit('enable_disable_loader', false));
    },
    resendActivationOtpCode() {
      axios.post('/account/ResendActivationOtpCode', { Value: this.activationCode })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$notify({ duration: 10000, group: 'app', text: this.$t('login.OtpCodeSentMessage'), type: '' });
          }
        });
    },
    confirmLink() {
      if (!this.activationCode == null || this.activationCode == '') {
        this.handleAcitvationResponse({ result: 0 });
      }
      else {
        var parameter = this.bOTPEnabled ? { Value: this.activationCode, OtpCode: this.otpCode } : { Value: this.activationCode };
        axios.post('/account/ActivateAccount', parameter)
          .then(response => {
            if (response.data.data.status == 0) {
              this.message = 'Email address confirmed, you will be redirected to login page in a moment.';
              this.accountActivated = true;
              setTimeout(() => this.login(), 3000);
            }
            else {
              this.handleAcitvationResponse(response.data);
            }
          })
          .catch(e => {
            this.accountActivated = false;
            console.log(e);
            this.message = e.Message;
          })
      }
    },
    handleAcitvationResponse(resp) {
      this.accountActivated = false;
      this.errorMessage = this.activateAccountResultErrors[resp.result];
    },
  },
}
